import Enumerable from "linq";

export class Arguments {
  constructor(private readonly _arguments: string[]) {
  }

  contains(key: string): boolean {
    return (0 <= this._arguments.indexOf(key));
  }

  getValue(key: string): string {
    const index = this._arguments.indexOf(key) + 1;
    return ((0 < index) && (index < this._arguments.length))
      ? this._arguments[index]
      : null;
  }

  toString(): string {
    return Enumerable.from(this._arguments)
      .select(a => "\"" + a + "\"")
      .toArray()
      .join(" ");
  }
}
